"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
function addParams(url, params) {
    if (!params)
        return url;
    const strparams = Object.entries(params)
        .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
        .join('&');
    const c = url.includes('?') ? '&' : '?';
    return url + c + strparams;
}
class LaravelAPIPaginator {
    constructor(method, url, post_data, params, cb, array = []) {
        this.response = null;
        this.working = false;
        this.aborted = false;
        this.method = method;
        this.url = url;
        this.post_data = post_data;
        this.params = params;
        this.callback = cb;
        this.array = array;
    }
    async next() {
        // First time
        let url = addParams(this.url, this.params);
        // Other times
        if (this.response)
            url = this.response.next_page_url;
        // This is the end
        if (!url)
            return null;
        switch (this.method) {
            case 'get':
                this.response = (await axios_1.default.get(url)).data;
                break;
            case 'post':
                this.response = (await axios_1.default.post(url, this.post_data)).data;
                break;
            default:
                throw new Error("LaravelAPIPaginator not supported method");
        }
        return this.response.data;
    }
    async all(reactiveFunction) {
        var _a, _b;
        if (this.working) {
            throw ".all() called multiple times for a LaravelAPIPaginator";
        }
        this.working = true;
        let part = null;
        while (!this.aborted) {
            part = await this.next();
            if (this.callback) {
                this.callback((_a = this.response) === null || _a === void 0 ? void 0 : _a.current_page, (_b = this.response) === null || _b === void 0 ? void 0 : _b.last_page, this);
            }
            await (0, sleep_1.default)(100);
            if (!part)
                break;
            if (reactiveFunction) {
                part.forEach((item) => this.array.push(reactiveFunction(item)));
            }
            else {
                this.array = [...this.array, ...part];
            }
        }
        this.working = false;
        return this.array;
    }
    async abort() {
        this.aborted = true;
        while (this.working) {
            await (0, sleep_1.default)(100);
        }
    }
    static get(url, params, cb, array = []) {
        return new LaravelAPIPaginator('get', url, undefined, params, cb, array);
    }
    static post(url, post_data, params, cb) {
        return new LaravelAPIPaginator('post', url, post_data, params, cb);
    }
}
exports.default = LaravelAPIPaginator;
